import Button from "components/ui/button"
import { IS_NA, IS_CA, IS_US, IS_INT } from "helpers/application"
import { to_currency } from "helpers/number"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()

  return () => {
    try {
      if (IS_NA()) {
        const attentiveBoxID = isMobile
          ? IS_US()
            ? 1253929 // US Mobile
            : 1253941 // CA Mobile
          : IS_US()
            ? 1253936 // US Desktop
            : 1253947 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
      } else if (IS_INT()) {
        const globaleBoxID = "aad9ec14-0fee-4e96-8720-019925259926" // global e 316285
        window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        const lightboxID = "747cb6fb-aca2-4409-9161-34d11a7034c1" // 316155 Spinning Wheel
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

const FooterSubscribe = () => {
  const showWinContest = !IS_CA()

  const triggerPopup = usePopupTrigger()

  return (
    <div className="bg-primary text-white">
      <div className="tablet:items-center tablet:gap-48 contained-wide tablet:flex-row widescreen:px-60 widescreen:py-60 tablet:px-32 flex flex-col items-start justify-between px-16 py-32">
        <h2 className="display-md leading-72 desktop:leading-none tablet:mb-0 mb-24 shrink-0 whitespace-nowrap font-bold">
          Stay
          <wbr /> in touch
        </h2>
        <div className="tablet:w-auto tablet:items-end xlarge:items-center xlarge:flex-row flex w-full flex-col items-start">
          <p className="xlarge:mr-64 tablet:text-right body-lg desktop:font-semibold desktop:leading-none tablet:mb-8 xlarge:mb-0 mb-24 whitespace-nowrap font-normal">
            {IS_INT() ? (
              <>
                Subscribe to our
                <wbr /> emails and save 10%
              </>
            ) : showWinContest ? (
              <>
                Subscribe to our emails
                <wbr /> and spin to win
              </>
            ) : (
              <>
                Subscribe to our
                <wbr /> emails and win {to_currency(1500)}
              </>
            )}
          </p>
          <Button
            className="tablet:w-(--tablet-width) outline-black-print widescreen:w-(--widescreen-width) w-full uppercase"
            onClick={triggerPopup}
            style={{
              "--tablet-width": "230px",
              "--widescreen-width": "300px",
            }}
            variant="primary"
          >
            Get your code
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FooterSubscribe
